// extracted by mini-css-extract-plugin
export var addressFields = "_oz-0";
export var animationContainer = "_oz-1";
export var footer = "_oz-2";
export var lineItems = "_oz-3";
export var modalContent = "_oz-4";
export var orderName = "_oz-5";
export var strong = "_oz-6";
export var warning = "_oz-7";